import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DataService } from "../../../../services/data.service";
import { SpinnerService } from "shared-components";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
  selector: "app-grid-avisos-cultivos",
  templateUrl: "./grid-avisos-cultivos.component.html",
})
export class GridAvisosCultivosComponent implements OnInit {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 5;

  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public labels;
  public data;
  public dataDisplayed;

  public showCultivosSinDesignaciones = false;
  public showAforos = false;

  public columnId: number;

  @Input() titulo: string;

  @Output() refresh = new EventEmitter<boolean>();

  filtersVisible = false;
  public filtersForm: FormGroup;
  public paises: any;
  public denominaciones: any;
  public fincas: any;
  public productores: any;

  constructor(
    private readonly _translate: TranslateService,
    private readonly _dataService: DataService,
    private readonly _spinnerService: SpinnerService,
    private readonly fb: FormBuilder,
    private readonly _sessionContext: SessionContextService
  ) {
    this.filtersForm = this.fb.group({});
  }

  ngOnInit() {
    this.cultivosSinDesignacionTable();
    this.aforoActualAnterior();
    this.configureFilters();
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public get isSmallScreen() {
    return this._sessionContext.isSmallScreen();
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.itemsPerPage * page;
    //this.showCorrectTable();
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = items;
    this.firstItemList = 0;
    this.lastItemList = items;
    //this.showCorrectTable();
  }

  public getCultivosSinDesignaciones() {
    let filters = {};
    this.showCultivosSinDesignaciones = true;
    this._spinnerService.showSpinner();
    this._dataService
      .getCultivosSinDesignacionesTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  public getAforoCultvios(porcentajes, operador) {
    this.showAforos = true;
    let filters;
    if (operador === "<" && !porcentajes.min) {
      filters = {
        porcentajeMin: null,
        porcentajeMax: porcentajes.max,
      };
    } else if (operador === "<" && porcentajes.max) {
      filters = {
        porcentajeMin: porcentajes.min,
        porcentajeMax: porcentajes.max,
      };
    } else if (operador === ">" && porcentajes.max === 130) {
      filters = {
        porcentajeMin: porcentajes.min,
        porcentajeMax: porcentajes.max,
      };
    } else if (operador === ">" && !porcentajes.max) {
      filters = {
        porcentajeMin: porcentajes.min,
        porcentajeMax: null,
      };
    }
    this._spinnerService.showSpinner();
    this._dataService
      .getKgAforoRespectoAnteriorTabla(filters)
      .toPromise()
      .finally(() => {
        this._spinnerService.hideSpinner();
      })
      .then((resp) => {
        if (resp) {
          this.totalItems = resp.paginacionMeta.totalCount;
          this.data = resp.lista;
          this.dataDisplayed = this.data;
          this.fillMultis();
        }
      });
  }

  public cultivosSinDesignacionTable() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.cultivos.cultivosSinDesignaciones.label"
      ) +
        " "
    ) {
      this.getCultivosSinDesignaciones();
    }
  }

  public aforoActualAnterior() {
    if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.cultivos.aforoActualAnterior.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.cultivos.aforoActualAnterior.postLabel"
        ) +
        " (<70%)"
    ) {
      this.getAforoCultvios({ min: null, max: 70 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.cultivos.aforoActualAnterior.preLabel"
      ) +
        "<" +
        this._translate.instant(
          "central-avisos.cultivos.aforoActualAnterior.postLabel"
        ) +
        " (70%-80%)"
    ) {
      this.getAforoCultvios({ min: 70, max: 80 }, "<");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.cultivos.aforoActualAnterior.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.cultivos.aforoActualAnterior.postLabel"
        ) +
        " (20%-30%)"
    ) {
      this.getAforoCultvios({ min: 120, max: 130 }, ">");
    } else if (
      this.titulo ===
      this._translate.instant(
        "central-avisos.cultivos.aforoActualAnterior.preLabel"
      ) +
        ">" +
        this._translate.instant(
          "central-avisos.cultivos.aforoActualAnterior.postLabel"
        ) +
        " (>30%)"
    ) {
      this.getAforoCultvios({ min: 130, max: null }, ">");
    }
  }

  public showCorrectTable() {
    if (this.showCultivosSinDesignaciones) {
      this.cultivosSinDesignacionTable();
    } else if (this.showAforos) {
      this.aforoActualAnterior();
    }
  }

  public close() {
    this.refresh.emit(true);
  }

  public toOrderBy(id: number) {
    this.columnId = id;
  }

  public getSortIcon(id: number) {
    let iconClass = "fa fa-sort";
    if (id === this.columnId) {
      const selectedColumn = document.querySelectorAll("th")[id - 1];
      iconClass =
        selectedColumn.dataset.order === "desc"
          ? "fa fa-sort-up"
          : "fa fa-sort-down";
    }
    return iconClass;
  }

  shareCheckedListPaises(item: any[]) {
    if (item) {
      this.filtersForm.get("pais").patchValue(item);
    }
  }

  shareCheckedListDenominaciones(item: any[]) {
    if (item) {
      this.filtersForm.get("denominacion").patchValue(item);
    }
  }

  shareCheckedListFincas(item: any[]) {
    if (item) {
      this.filtersForm.get("finca").patchValue(item);
    }
  }

  shareCheckedListProductores(item: any[]) {
    if (item) {
      this.filtersForm.get("productor").patchValue(item);
    }
  }

  clearFormGroup(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) =>
      formGroup.removeControl(key)
    );
  }

  private configureFilters() {
    // Limpia el formgroup antes de añadir los controles.
    this.clearFormGroup(this.filtersForm);

    this.filtersForm.addControl("pais", new FormControl([]));
    this.filtersForm.addControl("denominacion", new FormControl([]));
    this.filtersForm.addControl("finca", new FormControl([]));
    this.filtersForm.addControl("productor", new FormControl([]));

    if (this.showAforos) {
      this.filtersForm.addControl("aforoActual", new FormControl(""));
    }
  }

  fillMultis() {
    this.paises = this.getUniqueValues(this.data, "desPais", "paisId");
    this.denominaciones = this.getUniqueValues(
      this.data,
      "desDenominacion",
      "denominacionId"
    );
    this.fincas = this.getUniqueValues(
      this.data,
      "desFinca",
      this.showAforos ? "fincaId" : "id"
    );

    this.productores = this.getUniqueValues(
      this.data,
      "desProductor",
      "productorId"
    );
  }

  private getUniqueValues(data: any[], key: string, idKey: string) {
    // Crea un mapa para almacenar los valores únicos
    const uniqueMap = new Map();

    // Itera sobre los datos y almacena los valores únicos en el mapa
    data.forEach((item, index) => {
      if (item[idKey] === null || item[idKey] === undefined) {
        item[idKey] = index;
      }
      if (
        !uniqueMap.has(item[key]) &&
        item[key] !== null &&
        item[key] !== undefined
      ) {
        uniqueMap.set(item[key], item[idKey]);
      }
    });

    // Convierte el mapa en un array con la estructura deseada
    let uniqueArray = Array.from(uniqueMap, ([des, id]) => ({ id, des }));

    // Ordena el array alfabéticamente por la propiedad 'des'
    uniqueArray.sort((a, b) => {
      if (a.des.toLowerCase() < b.des.toLowerCase()) {
        return -1;
      }
      if (a.des.toLowerCase() > b.des.toLowerCase()) {
        return 1;
      }
      return 0;
    });

    return uniqueArray;
  }

  public filtrar() {
    const selectedPaises = this.filtersForm.get("pais")?.value;
    const selectedDenominaciones = this.filtersForm.get("denominacion")?.value;
    const selectedFincas = this.filtersForm.get("finca")?.value;
    const selectedProductores = this.filtersForm.get("productor")?.value;
    const aforoActual = this.filtersForm.get("aforoActual")?.value;

    this.dataDisplayed = this.data;

    if (selectedPaises && selectedPaises.length > 0) {
      this.dataDisplayed = this.filterDataByIds(
        this.dataDisplayed,
        selectedPaises,
        "paisId"
      );
    }

    if (selectedDenominaciones && selectedDenominaciones.length > 0) {
      this.dataDisplayed = this.filterDataByIds(
        this.dataDisplayed,
        selectedDenominaciones,
        "denominacionId"
      );
    }

    if (selectedFincas && selectedFincas.length > 0) {
      this.dataDisplayed = this.filterDataByIds(
        this.dataDisplayed,
        selectedFincas,
        this.showAforos ? "fincaId" : "id"
      );
    }

    if (selectedProductores && selectedProductores.length > 0) {
      this.dataDisplayed = this.filterDataByIds(
        this.dataDisplayed,
        selectedProductores,
        "productorId"
      );
    }

    if (this.showAforos) {
      if (aforoActual) {
        this.dataDisplayed = this.filterDataByNumber(
          this.dataDisplayed,
          aforoActual,
          "porcentaje"
        );
      }
    }
    // Update paginator table
    this.firstItemList = 0;
    this.currentPage = 1;
    this.lastItemList = this.itemsPerPage;
    this.totalItems = this.dataDisplayed.length;
  }

  private filterDataByIds(data: any[], selectedIds: number[], key: string) {
    if (!selectedIds || selectedIds.length === 0) {
      return data; // Si no hay IDs seleccionados, no filtrar los datos
    }
    return data.filter((item) => selectedIds.includes(item[key]));
  }

  private filterDataByNumber(data: any[], threshold: number, key: string) {
    return data.filter((item) => item[key] > threshold);
  }
}
